import { useState } from 'react'

import { PREVIEW_SECTIONS } from '@/constants/eventPreviewLabels'

/**
 * Custom hook to manage the state of the event preview modal.
 * @returns {{
 *   openSections: { [section: string]: boolean },
 *   toggleSection: (section: string) => void
 * }} An object containing:
 *   - openSections: An object mapping section names to their open/closed state.
 *   - toggleSection: Function to toggle the open/closed state of a section.
 */
export const useEventPreview = () => {
  const [openSections, setOpenSections] = useState({
    [PREVIEW_SECTIONS.DETAILS]: true,
    [PREVIEW_SECTIONS.DATES]: true,
    [PREVIEW_SECTIONS.DISPLAY]: true
  })

  const toggleSection = (section) => {
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }))
  }

  return {
    openSections,
    toggleSection
  }
}
